/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import Banner from 'common/components/banner/banner';
import * as React from 'react';

// eslint-disable-next-line no-restricted-imports
import { forNamespace } from 'common/lib/util/i18n';

import styles from './small-team-boards-cta-banner.less';

interface NarrowBannerProps {
  teamName: string;
  teamBoardsLink: string;
  onDismiss: () => void;
  onClickLink?: React.EventHandler<React.MouseEvent<HTMLElement>>;
}

const NarrowBanner = (props: NarrowBannerProps) => {
  const format = forNamespace('board section banner');

  return (
    <Banner
      onDismiss={props.onDismiss}
      inlinePadding
      roundedCorners
      alignCloseTop
    >
      <div className={styles.boardsMenuBanner}>
        <div className={styles.boardsMenuBannerEmoji}>👀</div>
        <div className="text">
          {format('access to lots of boards', {
            teamName: props.teamName,
          })}{' '}
          <a href={props.teamBoardsLink} onClick={props.onClickLink}>
            {format('check them out')}
          </a>
        </div>
      </div>
    </Banner>
  );
};

export default NarrowBanner;



// WEBPACK FOOTER //
// ./app/scripts/views/member/team-boards-cta/narrow-team-boards-cta-banner.tsx